/* eslint-disable no-unused-vars */

import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';
import Masonry from 'react-masonry-component';

import Filter from '.././Components/Filter';
import MasonryData from '.././Components/MasonryData';

class Story extends React.Component {
  constructor(props) {
    super();
    this.state = {
      apiUrl: window.$apiUrl,
      PopulatedData: [],
    };
  }
  
  getStoryList() {
    fetch(this.state.apiUrl + '/StoryAPI/GetStoryList', {
      method: 'POST',
      headers: {
        'token': process.env.REACT_APP_API_TOKEN,
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-origin': '*'
      },
      body: JSON.stringify({
        "Start_Index": 1,
        "Max_Rows": 100,
        "Status": 1,
        "Is_Publish": 1
      })
    })
      .then(res => res.json())
      .then((data) => {
        if (data.Status === 'OK') {
          let Populated = this.state.PopulatedData;
          data.StoryDetail.forEach(function (item) {
              Populated.push(item);
          });

          this.setState({ PopulatedData: Populated });
        }
      })
      .catch(console.log);
  }

  componentDidMount(){
    this.getStoryList();
  }

  render() {

    return (
      <div className="Story">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 pt-md-5 pb-md-3 py-3 text-center">
              <div className="position-relative d-flex justify-content-center">
                <img src="images/slice/2.stories/stories/stories-header.png" className="img-fluid" />
                <div className="position-absolute text-center title-stories pl-5" style={{ top: '38%' }}>
                  Stories By Past Teams
                </div>
              </div>
            </div>
          </div>
          {/* <Filter /> */}
          <div className="overflow-hidden" style={{ maxHeight: '600px' }}><MasonryData PopulatedData={this.state.PopulatedData}  /></div>
          <div className="row">
            <div className="col-md-12 d-flex justify-content-center my-5">
              <Link to="/stories" className="btn btn-outline-primary">VIEW STORY</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Story;

